var _style, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateCog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137 135.1",
    style: {
      enableBackground: "new 0 0 137 135.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#1D1D1B;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 137,
    height: 135.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    className: "st1",
    d: "M4.2,41.6c0.7,0,1.3-0.2,1.9-0.5L6.4,41c-14.7,34.3,1.3,74,35.6,88.7 c21.7,9.3,46.6,6.6,65.8-7.1c1.9-1.4,2.3-4,1-5.9c-1.4-1.9-4-2.3-5.9-1l0,0c-26.6,18.9-63.5,12.7-82.5-13.9 C8.7,85.3,6.2,64,13.8,45.3l0,0.3c0.2,2.3,2.2,4.1,4.5,3.9s4.1-2.2,3.9-4.5l-1-14.5c0,0,0,0,0,0c-0.2-2.3-2.2-4.1-4.5-3.9 c-0.6,0-1.1,0.2-1.6,0.5L2.3,33.6c-2.1,1.1-2.9,3.6-1.8,5.7C1.2,40.7,2.7,41.6,4.2,41.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    className: "st1",
    d: "M34.2,19.5C60.8,0.5,97.7,6.7,116.7,33.3c11.7,16.5,14.2,37.8,6.6,56.5l0-0.3 c-0.2-2.3-2.2-4.1-4.5-3.9s-4.1,2.2-3.9,4.5l0,0l1,14.5c0,0,0,0,0,0c0.2,2.3,2.2,4.1,4.5,3.9c0.6,0,1.1-0.2,1.6-0.5l12.8-6.6 c2.1-1.1,2.9-3.6,1.8-5.7c-1.1-2.1-3.6-2.9-5.7-1.8l-0.2,0.1c14.7-34.3-1.3-74-35.6-88.7c-21.7-9.3-46.6-6.6-65.8,7.1 c-1.9,1.4-2.3,4-1,5.9C29.6,20.4,32.3,20.8,34.2,19.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    className: "st1",
    d: "M29.3,75.8c-1.5,0.3-2.4,1.7-2.1,3.2c0,0.1,0,0.1,0,0.2c0.9,3.2,2.2,6.4,3.9,9.3 c0.7,1.3,2.4,1.8,3.7,1c0.1,0,0.1-0.1,0.2-0.1c3.9-2.6,9.1-1.6,11.7,2.3c1.9,2.8,1.9,6.5,0,9.4c-0.8,1.2-0.5,2.9,0.7,3.7 c0.1,0,0.1,0.1,0.2,0.1c2.9,1.7,6.1,2.9,9.3,3.9c1.4,0.4,2.9-0.4,3.3-1.9c0-0.1,0-0.1,0-0.2c0.9-4.6,5.4-7.5,9.9-6.6 c3.3,0.7,6,3.3,6.6,6.6c0.3,1.5,1.7,2.4,3.2,2.1c0.1,0,0.1,0,0.2,0c3.3-0.9,6.4-2.2,9.3-3.9c1.3-0.7,1.8-2.4,1-3.7 c0-0.1-0.1-0.1-0.1-0.2c-2.6-3.9-1.6-9.1,2.3-11.7c2.8-1.9,6.6-1.9,9.4,0c1.2,0.8,2.9,0.5,3.7-0.7c0-0.1,0.1-0.1,0.1-0.2 c1.7-2.9,3-6.1,3.9-9.3c0.4-1.4-0.4-2.9-1.9-3.3c-0.1,0-0.1,0-0.2,0l0,0c-4.6-0.9-7.5-5.3-6.6-9.9c0.7-3.4,3.3-6,6.6-6.6 c1.5-0.3,2.4-1.7,2.1-3.2c0-0.1,0-0.1,0-0.2c-0.9-3.2-2.2-6.4-3.9-9.3c-0.7-1.3-2.4-1.8-3.7-1c-0.1,0-0.1,0.1-0.2,0.1 c-3.9,2.6-9.1,1.6-11.7-2.3c-1.9-2.8-1.9-6.5,0-9.4c0.8-1.2,0.5-2.9-0.7-3.7c-0.1,0-0.1-0.1-0.2-0.1c-2.9-1.6-6.1-2.9-9.3-3.8 c-1.4-0.4-2.9,0.4-3.3,1.9c0,0.1,0,0.1,0,0.2c-0.9,4.6-5.4,7.5-9.9,6.6c-3.3-0.7-5.9-3.3-6.6-6.6C60,27,58.5,26,57.1,26.3 c-0.1,0-0.1,0-0.2,0c-3.3,0.9-6.4,2.2-9.3,3.9c-1.3,0.7-1.8,2.4-1,3.7c0,0.1,0.1,0.1,0.1,0.2c2.6,3.9,1.5,9.1-2.3,11.7 c-2.8,1.9-6.6,1.9-9.4,0c-1.2-0.8-2.9-0.5-3.7,0.7c0,0.1-0.1,0.1-0.1,0.2c-1.7,2.9-3,6.1-3.9,9.3c-0.4,1.4,0.4,2.9,1.9,3.3 c0.1,0,0.1,0,0.2,0c4.6,0.9,7.5,5.3,6.6,9.9C35.3,72.5,32.6,75.2,29.3,75.8 M68.5,50.4c9.5,0,17.1,7.7,17.1,17.2 c0,9.5-7.7,17.1-17.2,17.1c-9.5,0-17.1-7.7-17.1-17.2C51.3,58.1,59,50.4,68.5,50.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    className: "st1",
    d: "M78.8,67.6c0,5.7-4.6,10.3-10.3,10.3c-5.7,0-10.3-4.6-10.3-10.3c0-5.7,4.6-10.3,10.3-10.3 c0,0,0,0,0,0C74.2,57.3,78.8,61.9,78.8,67.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateCog);
export default __webpack_public_path__ + "static/media/update-cog.209c619dc5b0218b17331f3db7224c8d.svg";
export { ForwardRef as ReactComponent };